import ConfirmTransferDetailsView from './ConfirmTransferDetailsView';

export default ConfirmTransferDetailsView;
